import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AgreementService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";

  constructor(private http: HttpClient) { }

  getVenueAgreements(venue_id: number): Observable<MultipleAgreementResponse> {
    return this.http.get<MultipleAgreementResponse>(this.rootUri + `/api/agreement/by-venue/${venue_id}`);
  }

  getClientAgreements(client_id: number): Observable<MultipleAgreementResponse> {
    return this.http.get<MultipleAgreementResponse>(this.rootUri + `/api/agreement/by-client/${client_id}`);
  }

  updateAgreement(agreement_id: number, data: any): Observable<SingleAgreementResponse> {
    return this.http.post<SingleAgreementResponse>(`${this.rootUri}/api/agreement/${agreement_id}/update`, data);
  }

  newAgreement(data: any): Observable<SingleAgreementResponse> {
    return this.http.post<SingleAgreementResponse>(`${this.rootUri}/api/agreement/new`, data);
  }

  newAgreementChange(agreement_id: number, data: any): Observable<SingleAgreementResponse> {
    return this.http.post<SingleAgreementResponse>(`${this.rootUri}/api/agreement/${agreement_id}/new-change`, data);
  }

  deleteAgreement(agreement_id: number, kt_event_id: number): Observable<SuccessResponse> {
    return this.http.post<SuccessResponse>(`${this.rootUri}/api/agreement/${agreement_id}/delete`, { kt_event_id: kt_event_id });
  }

  removeAgreementChange(agreement_id: number, data: any): Observable<SingleAgreementResponse> {
    return this.http.post<SingleAgreementResponse>(`${this.rootUri}/api/agreement/${agreement_id}/undo-change`, data);
  }

}
